import { Component } from '@angular/core';

@Component({
  selector: 'app-student-verification-link',
  templateUrl: './student-verification-link.component.html',
  styleUrls: ['./student-verification-link.component.scss']
})
export class StudentVerificationLinkComponent {

}
